import * as React from 'react';

function SvgCardOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.527, d: "M19.308 4.308H4.692A2.692 2.692 0 002 7v10a2.692 2.692 0 002.692 2.692h14.616A2.692 2.692 0 0022 17V7a2.692 2.692 0 00-2.692-2.692z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 2.862, d: "M2.256 8.924h18.975M5.846 14.116h2.308v.962H5.846v-.962z" })));
}

export default SvgCardOutline;
